function SummerPricing({ screenWidth, handleOpenSXPSite }) {
  return (
    <div class="w3-row-padding w3-center w3-padding-64" id="pricing">
      <h2>Summer Programmes</h2>
      <p>Choose a programme that fits your needs.</p>
      <br></br>
      <div style={{ display: "flex", flexWrap: "wrap", flexDirection: "row" }}>
        <div
          class="w3-third w3-margin-bottom"
          style={{
            width: screenWidth === "Small" ? "99%" : "",
          }}
        >
          <ul class="w3-ul w3-border w3-hover-shadow">
            <li class="w3-theme">
              <p class="w3-xlarge">1 Week</p>
            </li>
            <li class="w3-padding-16">
              <b>25</b> contact hours with professionals
            </li>
            <li class="w3-padding-16">
              <b>Up to 2</b> Excursions to professional workplaces/venues
            </li>
            <li class="w3-padding-16">Hands-on career simulations</li>
            <li class="w3-padding-16">
              Programme materials, equipment & resources
            </li>
            <li class="w3-padding-16">Digital certificate</li>
            <li class="w3-padding-16">On-site safeguarding & pastoral care</li>
            <li class="w3-padding-16">Experience UCL campus</li>
            <li class="w3-padding-16">
              <h2 class="w3-wide">
                <i class="fa fa-gbp"></i> 2,225
              </h2>
              <span class="w3-opacity">Residential package +£1,500</span>
            </li>
            {/* <li class="w3-theme-l5 w3-padding-24">
              <button
                class="w3-button w3-teal w3-padding-large"
                onClick={handleOpenSXPSite}
              >
                <i class="fa fa-check"></i> See full details on our website
              </button>
            </li> */}
          </ul>
        </div>

        <div
          class="w3-third w3-margin-bottom"
          style={{
            width: screenWidth === "Small" ? "99%" : "",
          }}
        >
          <ul class="w3-ul w3-border w3-hover-shadow">
            <li class="w3-theme-l2">
              <p class="w3-xlarge">2 Week</p>
            </li>
            <li class="w3-padding-16">
              <b>50</b> contact hours with professionals
            </li>
            <li class="w3-padding-16">
              <b>Up to 5</b> Excursions to professional workplaces/venues
            </li>
            <li class="w3-padding-16">
              + Assessment centre to improve on core skills & receive feedback
            </li>
            <li class="w3-padding-16">
              + Graduation ceremony & physical certificate
            </li>
            <li class="w3-padding-16">
              <b>+ £375</b> Level 3 Award in Work Experience & Assessment for
              UCAS Points
            </li>
            <li class="w3-padding-16" style={{ color: "grey" }}>
              .
            </li>
            <li class="w3-padding-16" style={{ color: "grey" }}>
              .
            </li>
            <li class="w3-padding-16">
              <h2 class="w3-wide">
                <i class="fa fa-gbp"></i> 3,275
              </h2>
              <span class="w3-opacity">Residential package +£3,150</span>
            </li>
            {/* <li class="w3-theme-l5 w3-padding-24">
              <button
                class="w3-button w3-teal w3-padding-large"
                onClick={handleOpenSXPSite}
              >
                <i class="fa fa-check"></i> See full details on our website
              </button>
            </li> */}
          </ul>
        </div>

        <div
          class="w3-third w3-margin-bottom"
          style={{
            width: screenWidth === "Small" ? "99%" : "",
          }}
        >
          <ul class="w3-ul w3-border w3-hover-shadow">
            <li class="w3-theme">
              <p class="w3-xlarge">2 Week Premium</p>
            </li>
            <li class="w3-padding-16">
              <b>65</b> contact hours with professionals
            </li>
            <li class="w3-padding-16">
              <b>Up to 5</b> Excursions to professional workplaces/venues
            </li>
            <li class="w3-padding-16">
              + Level 3 Award in Work Experience & Assessment for{" "}
              <b>UCAS Points</b>
            </li>
            <li class="w3-padding-16"> + Experience LSE campus </li>{" "}
            <li class="w3-padding-16">
              + Personalised professional development & university admissions
              coaching{" "}
            </li>{" "}
            <li class="w3-padding-16">
              + Personality & situational judgement testing{" "}
            </li>{" "}
            <li class="w3-padding-16">
              + Private Gala dinner & networking event with professionals{" "}
            </li>
            <li class="w3-padding-16">
              <h2 class="w3-wide">
                <i class="fa fa-gbp"></i> 4,400
              </h2>
              <span class="w3-opacity">Residential package +£3,150</span>
            </li>
            {/* <li class="w3-theme-l5 w3-padding-24">
              <button
                class="w3-button w3-teal w3-padding-large"
                onClick={handleOpenSXPSite}
              >
                <i class="fa fa-check"></i> See full details on our website
              </button>
            </li> */}
          </ul>
        </div>
      </div>
    </div>
  );
}

export default SummerPricing;
